import { Placement } from '@popperjs/core';
import React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';

import styles from './styles.css';

export interface TooltipProps {
  children: React.ReactElement;
  label: string;
  placement?: Placement;
}

const Tooltip: React.FC<TooltipProps> = ({ children, label, placement }) => {
  const { getArrowProps, getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip({
    placement,
    offset: [0, 12],
  });

  return (
    <>
      {React.cloneElement(children, { ref: setTriggerRef })}
      {visible && (
        <div ref={setTooltipRef} {...getTooltipProps({ className: styles['tooltip-container'] })}>
          <div {...getArrowProps({ className: styles['tooltip-arrow'] })} />
          <p>{label}</p>
        </div>
      )}
    </>
  );
};

export default Tooltip;
